export const selectThemeColors = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#7367f0", // for selected option bg-color
      neutral30: "#7367f0" // for input hover border-color
    }
  });
